import { Alert, SearchIcon, Text, TextLink } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import { useNavigation } from '@redbubble/next-provider';
import React from 'react';
import { messages } from './messages';
import styles from './SuggestionBanner.module.scss';

interface SuggestionBannerProps {
  suggestion: {
    originalQuery: string;
    suggestedQuery: string;
    suggestionUsed: boolean;
  };
  formattedQuery: string | null;
}

export const SuggestionBanner: React.FC<SuggestionBannerProps> = ({
  suggestion,
  formattedQuery = null,
}) => {
  const { navigate } = useNavigation();
  const intl = useIntl();

  const handleQueryClick = (query: string) => {
    if (query) {
      // Get current URL and update just the query parameter
      const currentUrl = new URL(window.location.href);
      const searchParams = new URLSearchParams(currentUrl.search);

      // Update the query parameter with the new search term
      searchParams.set('query', query);
      searchParams.set('includeSuggestion', 'false');

      // Navigate to /shop with updated query parameters
      const newUrl = `/shop?${searchParams.toString()}`;
      navigate({ url: newUrl });
    }
  };

  const didYouMeanSuggestion =
    formattedQuery?.replace(
      suggestion.originalQuery,
      suggestion.suggestedQuery
    ) || suggestion.suggestedQuery;

  return (
    <Alert marginBottom="m" label={false} subtle banner>
      <div className={styles.container}>
        <SearchIcon />
        {suggestion.suggestionUsed ? (
          <Text marginLeft={0.5} textAlign="center">
            {intl.formatMessage(messages.search_instead_for, {
              suggestedQuery: suggestion.suggestedQuery,
              originalQuery: (
                <TextLink
                  onClick={() =>
                    handleQueryClick(formattedQuery || suggestion.originalQuery)
                  }
                >
                  {formattedQuery || suggestion.originalQuery}
                </TextLink>
              ),
            })}
          </Text>
        ) : (
          <Text marginLeft={0.5}>
            {intl.formatMessage(messages.did_you_mean, {
              suggestedQuery: (
                <TextLink
                  onClick={() => handleQueryClick(didYouMeanSuggestion)}
                >
                  {didYouMeanSuggestion}
                </TextLink>
              ),
            })}
          </Text>
        )}
      </div>
    </Alert>
  );
};
